// extracted by mini-css-extract-plugin
export default {"instagramBtn":"socialAuth_instagramBtn__+UnBW","socialIcon":"socialAuth_socialIcon__-pv0f"};